import MUIChip, { ChipProps as MUIChipProps } from "@mui/material/Chip";

const Chip = MUIChip;

export type ChipProps = MUIChipProps;
export default Chip;
